module.exports = __webpack_public_path__ + "static/media/logo-governo.f46eae84.webp";